
import {React,useState,useEffect} from 'react'
import './pages.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Axios from 'axios'
import Marquee from "react-fast-marquee";

export default function Register() {
    
    const[firstName, setFirstname] = useState('')
    const [surname,setSurname] = useState('');
    const[otherNames, setOthernames] = useState('');
    const [phone,setPhone] = useState('')
    const [IDNumber, setIDNumber] = useState('');
    const [KRAPin, setKRAPin] = useState('');
    const [DOB, setDOB] = useState('');
    const [confirmPassword, setConfirmpassword] = useState('')
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState('')
    const navigate = useNavigate();
    const [registerText,setRegistertext] = useState('Create Account')
    const [isChecked, setIsChecked] = useState(false);
    const [accountType, setAccounttype] = useState('Individual');
    const [opt, setOpt] = useState(1);
    const [code, setCode] = useState('');
    const [otp, setOtp] = useState('');

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
      };

    const toLogin=()=>{
        navigate('/login')
    }

    const submitUser =async()=>{
        if(firstName && phone && IDNumber && confirmPassword && email && password){
           
            setRegistertext('Please wait...')
            const res = await fetch('https://panel.yunshuglobal.com:3063/api/registerUser',{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({firstName,surname,otherNames,phone,IDNumber,password,email,accountType}),
                credentials:"include"
                
            })

            const data = await res.json();
            const {success,exists} = data;
            if(success==true && exists==false){
                toast.success('Account created successfully')
                toLogin();
                setRegistertext('Create Account')

            }
            else if(success==false && exists==true){
                toast.error('Details linked to an existing account!')
                setRegistertext('Create Account')

            }
            else{
                toast.error('Something went wrong!')
                setRegistertext('Create Account')
            }


            

        }
        else{
            toast.error('All fields marked * are required!')
        }
        
    }

    const confirmEmail =async()=>{
        if(isChecked){
        const randomCode = Math.floor(100000 + Math.random() * 900000); // generates a number between 100000 and 999999
            setCode(randomCode);

            setRegistertext('Please wait..')
            const res = await Axios.post('https://n8n.yunshuafrica.com/webhook/33c92827-8903-4b08-a31f-e27765d9a95e',{account:email,randomCode});
            setOpt(2)
            setRegistertext('Create Account')
        }
        else{
            toast.error("Please accept terms and conditions")
        }

    }

    const validate =()=>{
        if(otp == code){
            submitUser()
        }
        else{
            toast.error('Incorrect OTP')
        }
    }

  return (
    <div className='loginContainer'>
        <ToastContainer />
    <div className="loginMain">
            <div className="marquee">
            <Marquee>
                <h3>NOTICE: DEADLINE FOR REGISTRATION IS 8TH APRIL 2026</h3>
            </Marquee>

            </div>
        <div className="loginWrapper2">
            <h2 className='loginTitle'>Motor Claims Database</h2>
            <p className='slogan'>A Motor Claims Database For Court Action & Motor Insurance Reforms</p>
            {opt == 1 &&
                <>
                 <p className='loginText'>CREATE A FREE ACCOUNT </p>
            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Account type" onChange={(e)=>{setAccounttype(e.target.value)}}>
                <Form.Select  className='inputSearch'   > 
                <option selected disabled>Account type</option>
                <option value='Individual'>Individiual Owner</option>
                <option value='Corporate'>Saccos/Companies</option>

                </Form.Select>
            
            </FloatingLabel>

            {accountType == 'Individual' &&
                <div className="entryRow">
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="First name*" onChange={(e)=>{setFirstname(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={firstName}  type="text" placeholder="e.g JOHN" />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Surname*" onChange={(e)=>{setSurname(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={surname}  type="text" placeholder="e.g DOE" />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Other names" onChange={(e)=>{setOthernames(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={otherNames}  type="text" placeholder="e.g Other" />
                </FloatingLabel>

            </div>
            
            
            }
            {accountType == 'Corporate' &&
            <>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Company/Sacco name*" onChange={(e)=>{setFirstname(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={firstName}  type="text" placeholder="e.g XYZ Limited" />
                </FloatingLabel>
               
            </>
            }
            
           
            <div className="entryRow">
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email*" onChange={(e)=>{setEmail(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={email}  type="email" placeholder="email@example.com" />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Phone number*" onChange={(e)=>{setPhone(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={phone}  type="text" placeholder="e.g 0712365498" />
                </FloatingLabel>
                {accountType == 'Individual' &&
                        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="ID number*" onChange={(e)=>{setIDNumber(e.target.value)}}>
                                <Form.Control  className='inputSearch' value={IDNumber}  type="text" placeholder="e.g 12345678" />
                        </FloatingLabel>
                
                }
                {accountType == 'Corporate' &&
                        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Sacco number*" onChange={(e)=>{setIDNumber(e.target.value)}}>
                                <Form.Control  className='inputSearch' value={IDNumber}  type="text" placeholder="e.g 12345678" />
                        </FloatingLabel>
                
                }


            </div>
            <div className="entryRow">

                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Password*" onChange={(e)=>{setPassword(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={password}  type="password" placeholder="Password" />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Confirm password*" onChange={(e)=>{setConfirmpassword(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={confirmPassword}  type="password" placeholder="Confirm password" />
                </FloatingLabel>



            </div>
            <div>
                <label className='checkbox'>
                    <input
                    className='cb'
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    />
                     <a className='anchor' href="https://motorclaims.co.ke/terms">I agree to the terms and conditions</a>
                </label>
              
                </div>
           

            <Button color='info' className='loginButton' onClick={submitUser}>{registerText}</Button>
            <h1 className='pop' >ALREADY HAVE AN ACCOUNT?</h1>
                <button onClick={toLogin} className='signupButton2'>SIGN IN NOW</button>

           

                </>
            
            }
            {opt == 2 &&
            <>
             <p className='loginText'>Enter OTP sent to your email </p>
             <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter OTP" onChange={(e)=>{setOtp(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={otp}  type="text" placeholder="Enter OTP" />
                </FloatingLabel>
                <Button color='success' onClick={validate}>Validate</Button>

            </>
            
            }
           


        </div>
        
    </div>
    {/* <div className="loginSide">
        <div className="sideContainer">
  
                
                <div className="mpesaDetails">
                <img src="/mpesa.webp" alt=""  className='mpesaLogo'/>
                <p >PAYBILL: 247 247</p>
                <p>Account No: 667899</p>
                <hr />
                <p>Individual Owner: Kes. 10,000 /=</p>
                <p>Saccos/Companies: Kes. 20,000 /=</p>


                </div>
            <img src="/claimbanner1.jpg" alt="" className='banner1' />


           
        </div>

    </div> */}
</div>
  )
}
